import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { pushTag } from '@shared/analytics';
import { LoaderService } from '@shared/loader.service';
import { AppService } from '@shared/services/app.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EventsService } from '@shared/services';
import { RouterService } from '@shared/services/router.service';
import { UIconModule, UButtonModule } from '@local/ui-infra';
import { Constants } from '@local/common';
import { FeatureFlagEnabledDirective } from '@shared/directives/feature-flag-enabled.directive';

@UntilDestroy()
@Component({
  selector: 'page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [UButtonModule, UIconModule, FeatureFlagEnabledDirective],
})
export class PageNotFoundComponent implements OnInit, AfterViewInit {
  readonly DISABLED_HOME_WORKSPACE_FEATURE_FLAG = Constants.DISABLED_HOME_WORKSPACE_FEATURE_FLAG;

  readonly LOTTIE_ANIMATION = {
    lightUrl: '/assets/not-found/light.json',
    darkUrl: '/assets/not-found/dark.json',
    loop: true,
  };
  private url: string;

  constructor(
    private loaderService: LoaderService,
    private appService: AppService,
    private eventsService: EventsService,
    private routerService: RouterService
  ) {
    this.appService.windowStyle$.pipe(untilDestroyed(this)).subscribe((style) => {
      this.url = style != 'standard' ? '/search' : '/';
    });
  }

  ngOnInit() {
    pushTag({
      event: 'ng-pageview',
      pagePath: window.location.href.replace(location.origin, ''),
      pageTitle: 'Page not found',
    });
    this.telemetryEvent();
  }

  ngAfterViewInit(): void {
    this.loaderService.ready$.next(true);
  }

  telemetryEvent() {
    this.eventsService.event('status_view', {
      location: {
        title: 'not-found',
      },
      label: 'page_not_found',
    });
  }

  navigateToHomepage() {
    this.routerService.navigateByUrl(this.url);
  }
}
